<template>
  <!-- Adjust Dsign -->
  <div class="row">
    <div class="col-md-12">
      <div class="grid">
        <div class="grid-title">
          <h4>Adjust Design</h4>
        </div>
        <div class="grid-body">
          <div class="row mb-10">
            <div class="col-md-3">
              <label>Front</label>
              <input type="text" v-model="shirt.front" class="form-control" />
            </div>
            <div class="col-md-3">
              <label>Back</label>
              <input type="text" v-model="shirt.back" class="form-control" />
            </div>
            <div class="col-md-3">
              <label>Collar</label>
              <input type="text" v-model="shirt.collar" class="form-control" />
            </div>
            <div class="col-md-3">
              <label>Cuff</label>
              <input type="text" v-model="shirt.cuff" class="form-control" />
            </div>
          </div>

          <div class="row mb-10">
            <div class="col-md-3">
              <label>White Collar</label>
              <v-select
                label="production_name"
                placeholder="Choose One"
                v-model="shirt.collar_fabric_id"
                :options="pageData.fabrics"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
            <div class="col-md-3">
              <label>White Cuff</label>
              <v-select
                label="production_name"
                placeholder="Choose One"
                v-model="shirt.cuff_fabric_id"
                :options="pageData.fabrics"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
            <div class="col-md-3">
              <label>Initials</label>
              <input
                type="text"
                v-model="shirt.initials"
                class="form-control"
              />
            </div>
            <div class="col-md-3">
              <label>Initials Position</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.initial_position_id"
                :options="pageData.initialPositions"
                label="title"
                :reduce="(initialPositions) => initialPositions.id"
              />
            </div>
          </div>

          <div class="row mb-10">
            <div class="col-md-3">
              <label>Initials Font</label>
              <select v-model="shirt.initial_font" class="from-control select">
                <option value="handwriting">Handwriting</option>
                <option value="blockletter">Blockletter</option>
              </select>
            </div>
            <div class="col-md-3 mb-10">
              <label>Initials Thread Color</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.initial_thread_color_id"
                :options="pageData.embroideryThreadColors"
                label="title"
                :reduce="(embroideryThreadColors) => embroideryThreadColors.id"
              />
            </div>
            <div class="col-md-3">
              <label>Button Color</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.button_color_id"
                :options="pageData.buttonColors"
                label="title"
                :reduce="(buttonColors) => buttonColors.id"
              />
            </div>
            <div class="col-md-3">
              <label>Thread Color</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.thread_color_id"
                :options="pageData.threadColors"
                label="title"
                :reduce="(threadColors) => threadColors.id"
              />
            </div>
          </div>

          <div class="row mb-10">
            <div class="col-md-3">
              <label>Fabric</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.fabric_id"
                :options="pageData.fabrics"
                label="production_name"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
            <div class="col-md-3 mb-10">
              <label>Contrast Placket</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.inner_placket_fabric_id"
                :options="pageData.fabrics"
                label="production_name"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
            <div class="col-md-3">
              <label>Contrast Collar</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.inner_collar_fabric_id"
                :options="pageData.fabrics"
                label="production_name"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
            <div class="col-md-3">
              <label>Contrast Cuff</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.inner_cuff_fabric_id"
                :options="pageData.fabrics"
                label="production_name"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
          </div>

          <div class="row mb-10">
            <div class="col-md-3">
              <label>Pocket</label>
              <select v-model="shirt.pocket" class="from-control select">
                <template v-for="(pocket, index) in 10">
                  <option :value="index" :key="index" v-if="index == 0">
                    No Pocket
                  </option>
                  <option :value="index" :key="index" v-else>
                    Pocket - {{ index }}
                  </option>
                </template>
              </select>
            </div>
            <div class="col-md-3">
              <label>Lady Front Darts</label>
              <select
                v-model="shirt.lady_front_darts"
                class="from-control select"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>Lady Cuff Width</label>
              <select
                v-model="shirt.lady_cuff_width"
                class="from-control select"
              >
                <option value="0">0</option>
                <option value="4">4</option>
                <option value="7">7</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>Lady Cut</label>
              <select v-model="shirt.lady_cut" class="from-control select">
                <option value="0">N/A</option>
                <option value="1">Skinny Fit</option>
                <option value="2">Slim Fit</option>
                <option value="3">Loose</option>
              </select>
            </div>
          </div>

          <div class="row mb-10">
            <div class="col-md-3">
              <label>Bi Color Fabric</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.bi_color_fabric_id"
                :options="pageData.fabrics"
                label="production_name"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
            <div class="col-md-3">
              <label>Lady Requires Belt</label>
              <select
                v-model="shirt.lady_requires_belt"
                @change="
                  shirt.lady_belt_fabric_id =
                    shirt.lady_requires_belt == 0
                      ? null
                      : shirt.lady_belt_fabric_id
                "
                class="from-control select"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>Lady Belt Fabric</label>
              <v-select
                placeholder="Choose One"
                v-model="shirt.lady_belt_fabric_id"
                :options="pageData.fabrics"
                label="production_name"
                :reduce="(fabrics) => fabrics.id"
              />
            </div>
            <div class="col-md-3">
              <label>Lady Requires Loops</label>
              <select
                v-model="shirt.lady_requires_loops"
                class="from-control select"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div class="row mb-10">
            <div class="col-md-3">
              <label>Lady Requires Side Pockets</label>
              <select
                v-model="shirt.lady_requires_sidepockets"
                class="from-control select"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>Special Embroidery</label>
              <input
                type="text"
                v-model="shirt.special_embroidery"
                class="form-control"
              />
            </div>
            <div class="col-md-3">
              <label>Easy Packaging</label>
              <select
                v-model="shirt.easy_packaging"
                class="from-control select"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>Bottom Hem</label>
              <select
                v-model="shirt.straight_bottom"
                class="from-control select"
              >
                <option value="1">Straight Bottom</option>
                <option value="0">Regular</option>
              </select>
            </div>
          </div>

          <div class="row mt-10">
            <div class="col-md-12">
              <button
                class="btn btn-success btn-block"
                @click="updateDesign()"
                v-if="!isReadOnlyUser"
              >
                UPDATE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: {
    shirt: {
      type: Object,
      default: {},
    },
    pageData: {
      type: Object,
      default: {},
    },
    isReadOnlyUser: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async updateDesign() {
      let orderNumber = this.shirt.id;
      try {
        let res = await axios.put(
          "shirt_orders/update/shirt_order/" + orderNumber,
          {
            shirt: this.shirt,
            api_call: true,
          }
        );
        if (res) {
          Swal.fire("Success", "Successfully Updated", "success");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
  },
};
</script>
<style scoped>
.form-control {
  height: 42px !important;
  border-radius: 4px !important;
}
.mb-10 {
  margin-bottom: 10px !important;
}
.mt-10 {
  margin-top: 10px !important;
}
.select {
  width: 100% !important;
}
h4 {
  font-weight: bold !important;
}
.grid-title {
  border-top: 1px solid #eee;
}
</style>
